import ChurchSearchIcon from '../../../assets/images/church-search-icon.svg';
import SearchIcon from '../../../assets/images/search-dp.svg';
import {
  WelcomeSearchContainer,
  WelcomeSearchButton,
  WelcomeHeader,
  WelcomeDescription,
  ChurchSearchFooter,
  FooterContent,
  FooterDescription,
  WelcomeSearchBody,
} from './index.styled';

export const ChurchWelcomeLayout = ({ handleSearch, handleModalOpen }) => {
  return (
    <WelcomeSearchContainer>
      <WelcomeSearchBody>
        <div>
          <ChurchSearchIcon />
        </div>
        <WelcomeHeader>Welcome!</WelcomeHeader>
        <WelcomeDescription>
          <div>Find your church to login and join your church community.</div>
        </WelcomeDescription>
        <WelcomeSearchButton onClick={() => handleSearch(true)}>
          <span>
            <SearchIcon />
          </span>
          Search for Your Church
        </WelcomeSearchButton>
      </WelcomeSearchBody>
      <ChurchSearchFooter>
        <FooterContent>
          <span>Don’t see your church?</span>
          <span onClick={() => handleModalOpen('helper')}>Let Us Know</span>
        </FooterContent>
        <FooterDescription>
          <span>v1.1.1 (260)</span>
          <span>© 2022 Togather</span>
        </FooterDescription>
      </ChurchSearchFooter>
    </WelcomeSearchContainer>
  );
};
